import React, { FunctionComponent, ReactChild, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { IS_PRODUCTION } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { getProductTypeProviderValues } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/productTypeProviderUtils'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { LYRA_THEME_STORAGE_KEY } from '@lyrahealth-inc/ui-core-crossplatform/src/constants'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/productType/productTypeContext'

import { logToSumoLogic, SUMO_CATEGORY } from '../../common/utils/userUtils'
import { getCustomerProductType } from '../../data/customer/customerSelectors'
import { getId } from '../../data/user/userSelectors'

export const ProductTypeProvider: FunctionComponent<{
  children: ReactChild | ReactChild[]
}> = ({ children }) => {
  const { isLyraSelectEnabled, isAuroraEnabled, isWellbeingEnabled } = useFlags()
  const productType = useSelector(getCustomerProductType)
  const lyraId = useSelector(getId)
  const {
    isLyraSelect,
    isWellbeing,
    productType: computedProductType,
    isAuroraEnabled: computedIsAuroraEnabled,
  } = getProductTypeProviderValues({
    isLyraSelectEnabled,
    isWellbeingEnabled,
    isAuroraEnabled,
    productType,
  })

  const [essentialsTheme, setEssentialsTheme] = useState<string | null>(null)

  useEffect(() => {
    let storedTheme: string | null = null
    try {
      storedTheme = localStorage.getItem(LYRA_THEME_STORAGE_KEY)
    } catch (e) {
      console.error('Failed to read theme from localStorage', e)
      logToSumoLogic(IS_PRODUCTION ? SUMO_CATEGORY.PROD_DEBUG : SUMO_CATEGORY.STAGING_DEBUG, lyraId, {
        message: 'Failed to read theme from localStorage',
        type: 'error',
        error: e,
      })
    }
    const themeMode = storedTheme === 'dark' ? 'dark' : 'light'
    setEssentialsTheme(computedIsAuroraEnabled ? `aurora_${themeMode}` : 'wfmh')
  }, [computedIsAuroraEnabled, lyraId])

  return (
    <ProductTypeContext.Provider
      value={{
        isLyraSelect,
        isWellbeing,
        productType: computedProductType,
        isAuroraEnabled: computedIsAuroraEnabled,
        essentialsTheme,
        setEssentialsTheme,
      }}
    >
      {children}
    </ProductTypeContext.Provider>
  )
}
